// extracted by mini-css-extract-plugin
module.exports = {"gas-stats":"ChainGasDisplay_gas-stats__1MyfS"};